import React from 'react';
import '../../index.css';

export default function Products() {
  return <h1 className="products">PRODUCTS</h1>;
}
